import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!currentUser) {
    // Preserve both the intended destination and any query parameters
    const returnUrl = location.pathname;
    const searchParams = new URLSearchParams(location.search);
    const loginParams = new URLSearchParams();

    // Add the return URL
    loginParams.set('returnUrl', returnUrl);

    // Add any existing query parameters
    if (searchParams.has('tab')) {
      loginParams.set('tab', searchParams.get('tab')!);
    }

    return <Navigate to={`/login?${loginParams.toString()}`} />;
  }

  return <>{children}</>;
};
